import { useEffect, useState } from "react";

export default function TerminalMileagesCard({ terminalMileages }) {
  const [terminals, setTerminals] = useState();

  useEffect(() => {
    var terms = [];
    if (terminalMileages) {
      terminalMileages.forEach((t, idx) => {
        if (idx === 0) {
          terms.push([t.terminal_name, t.mileage]);
        } else {
          if (terminalMileages[idx - 1].terminal_name === t.terminal_name) {
            terms.push(["", t.mileage]);
          } else {
            terms.push([t.terminal_name, t.mileage]);
          }
        }
      });
    }
    setTerminals(terms);
  }, [terminalMileages]);

  return (
    <div className="col-3">
      <div className="p-2 border text-center project-card">
        <div className="d-flex justify-content-between project-header">
          <h5>Terminal Details</h5>
        </div>
        {terminals && (
          <div className="project-card-list">
            <table className="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Terminal</th>
                  <th>Mileage</th>
                </tr>
              </thead>
              <tbody>
                {terminals.map((t, idx) => (
                  <tr key={idx}>
                    <td>{t[0]}</td>
                    <td>{t[1]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
